import { getSettings, getServerSettings } from "../api/settings";
import { ISetting, IServerSettings } from "../models/get";

var settings: ISetting[];
var serverSettings: IServerSettings;

export enum SettingKey
{
    daysHiddenInWorkweek = "days_hidden_in_workweek",
    displayEventShowLabelInitials = "display.event.showLabelInitials",
    eventDialogChecks = "event_dialog_checks",
    eventFields = "event_fields",
    eventDVTemplate = "event_dv_template",
    eventMVTemplate = "event_mv_template",
    maxFilesizeAvatar = "max_filesize_avatar",
    notificationsEmailAcceptAllCertificates = "notifications.email.acceptAllCertificates",
    notificationsEmailActivated = "notifications.email.activated",
    notificationsEmailFromAddress = "notifications.email.fromAddress",
    notificationsEmailFromName = "notifications.email.fromName",
    notificationsEmailSendOrderConfirmationReport = "notifications.email.sendOrderConfirmationReport",
    notificationsEmailSendOrderConfirmationWhen ="notifications.email.sendOrderConfirmationWhen",
    notificationsEmailSmtpPassword = "notifications.email.smtpPassword",
    notificationsEmailSmtpPort = "notifications.email.smtpPort",
    notificationsEmailSmtpServer = "notifications.email.smtpServer",
    notificationsEmailSmtpUsername = "notifications.email.smtpUsername",
    notificationsEmailUseSsl = "notifications.email.useSsl",
    rulesCalendarsTimeGroups = "rules.calendars.timeGroups",
    dataProtectionUrl = "general.dataProtectionUrl",
    termsOfUseUrl = "general.termsOfUseUrl",
    licenceKey = "licence.key",
    imprint = "general.imprint",
    loginHeaderImage = "general.login.headerImage"
}

/**
 * Gibt alle Einstellungen zurück.
 * @param reload Angabe, ob die Einstellung erneut aus der Datenbank geladen werden sollen.
 */
export async function getSettingsAsync(reload: boolean = false): Promise<ISetting[]>
{
    if (settings == null || reload)
    {
        settings = await getSettings();
    }

    return settings;
}

/**
 * Gibt eine Bestimmte Einstellung zurück.
 * @param reload Angabe, ob die Einstellung erneut aus der Datenbank geladen werden sollen.
 */
export async function getSettingAsync<T>(key: SettingKey, reload: boolean = false): Promise<T>
{
    if (settings == null || reload)
    {
        settings = await getSettings();
    }

    return settings.where(s => s.id === key).first().settings;
}

export async function getServerSettingsAsync(reload: boolean = false): Promise<IServerSettings>
{
    if (serverSettings == null || reload)
    {
        serverSettings = await getServerSettings();
    }

    return serverSettings;
}